import type { MutableRefObject } from 'react';
import { PALETTE_BLOCKS } from '../blocks/blockLibrary';
import type { BlockType } from '../HtmlEditor.types';

type BlockPaletteProps = {
  dragTypeRef: MutableRefObject<BlockType | null>;
  onInsert: (type: BlockType) => void;
  disabled?: boolean;
};

export function BlockPalette({ dragTypeRef, onInsert, disabled }: BlockPaletteProps) {
  return (
    <>
      <div className='ee-palette__heading'>Blocchi</div>
      <div className='ee-blocks-grid'>
        {PALETTE_BLOCKS.map((b) => (
          <div
            key={b.type}
            className='ee-block-tile'
            draggable={!disabled}
            onDragStart={() => {
              dragTypeRef.current = b.type;
            }}
            onClick={() => {
              if (!disabled) onInsert(b.type);
            }}
            role='button'
            tabIndex={disabled ? -1 : 0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && !disabled) onInsert(b.type);
            }}
          >
            <div className='ee-block-tile__icon'>{b.glyph}</div>
            <div className='ee-block-tile__label'>{b.label}</div>
          </div>
        ))}
      </div>
    </>
  );
}
